import { render } from "./GroupSettingHead.vue?vue&type=template&id=e55a0344"
import script from "./GroupSettingHead.vue?vue&type=script&lang=js"
export * from "./GroupSettingHead.vue?vue&type=script&lang=js"
script.render = render

export default script